/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ lockedBy: NonNullable<unknown> }} Explorer_Table_Locked_TextInputs */

const en_explorer_table_locked_text = /** @type {(inputs: Explorer_Table_Locked_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This project is locked by ${i?.lockedBy}. You can view it, but to make changes you'll need to create a new copy.`)
};

const fr_explorer_table_locked_text = /** @type {(inputs: Explorer_Table_Locked_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ce projet est verrouille par ${i?.lockedBy}. Vous pouvez le consulter, mais pour modifier vous devez creer une nouvelle copie.`)
};

const de_explorer_table_locked_text = /** @type {(inputs: Explorer_Table_Locked_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dieses Projekt ist von ${i?.lockedBy} gesperrt. Sie können es ansehen, aber um Änderungen vorzunehmen, müssen Sie eine neue Kopie erstellen.`)
};

const it_explorer_table_locked_text = /** @type {(inputs: Explorer_Table_Locked_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Questo progetto è bloccato da ${i?.lockedBy}. Puoi visualizzarlo, ma per apportare modifiche dovrai crearne una nuova copia.`)
};

const ru_explorer_table_locked_text = /** @type {(inputs: Explorer_Table_Locked_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Этот проект заблокирован пользователем ${i?.lockedBy}. Вы можете просмотреть его, но для внесения изменений вам потребуется создать новую копию.`)
};

const es_explorer_table_locked_text = /** @type {(inputs: Explorer_Table_Locked_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Este proyecto está bloqueado por ${i?.lockedBy}. Puedes verlo, pero para hacer cambios tendrás que crear una nueva copia.`)
};

const zh_cn2_explorer_table_locked_text = /** @type {(inputs: Explorer_Table_Locked_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`此项目已被${i?.lockedBy}锁定。您可以查看，但要进行更改，您需要创建一个新的副本。`)
};

const ja_explorer_table_locked_text = /** @type {(inputs: Explorer_Table_Locked_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`このプロジェクトは${i?.lockedBy}によってロックされています。閲覧は可能ですが、変更を加えるには新しいコピーを作成する必要があります。`)
};

const hi_explorer_table_locked_text = /** @type {(inputs: Explorer_Table_Locked_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`यह प्रोजेक्ट ${i?.lockedBy} द्वारा लॉक किया गया है। आप इसे देख सकते हैं, लेकिन बदलाव करने के लिए आपको इसकी एक नई कॉपी बनानी होगी।`)
};

const pt_pt2_explorer_table_locked_text = /** @type {(inputs: Explorer_Table_Locked_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Este projeto está bloqueado por ${i?.lockedBy}. Você pode visualizá-lo, mas para fazer alterações, precisará criar uma nova cópia.`)
};

/**
* | output |
* | --- |
* | "This project is locked by {lockedBy}. You can view it, but to make changes you'll need to create a new copy." |
*
* @param {Explorer_Table_Locked_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_locked_text = /** @type {((inputs: Explorer_Table_Locked_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Locked_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_table_locked_text(inputs)
	if (locale === "de") return de_explorer_table_locked_text(inputs)
	if (locale === "it") return it_explorer_table_locked_text(inputs)
	if (locale === "ru") return ru_explorer_table_locked_text(inputs)
	if (locale === "es") return es_explorer_table_locked_text(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_table_locked_text(inputs)
	if (locale === "ja") return ja_explorer_table_locked_text(inputs)
	if (locale === "hi") return hi_explorer_table_locked_text(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_table_locked_text(inputs)
	return en_explorer_table_locked_text(inputs)
});